module.exports = __webpack_public_path__ + "static/media/womens2.054de7f4.jpg";